import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import './TestimonialsSection.css';
import avatar from '../../assets/avatar.jpg';
import { FaArrowLeft, FaArrowRight, FaRegStar, FaStar, FaStarHalfAlt } from 'react-icons/fa';

function TestimonialsSection() {
  const testimonials = [
    {
      avatar,
      name: 'João Silva',
      location: 'Conselheiro Lafaiete, MG',
      text: 'O serviço de internet da VitaLink é excelente. Conexão estável e rápida, perfeito para o meu trabalho.',
      rating: 5.0,
    },
    {
      avatar,
      name: 'Maria Oliveira',
      location: 'Conselheiro Lafaiete, MG',
      text: 'Atendimento impecável. Sempre que preciso, o suporte está disponível e resolve tudo rápido.',
      rating: 5.0,
    },
    {
      avatar,
      name: 'Carlos Souza',
      location: 'Conselheiro Lafaiete, MG',
      text: 'A melhor internet que já tive. Uso para assistir filmes e jogar online sem problemas.',
      rating: 4.5,
    },
    {
      avatar,
      name: 'Ana Paula',
      location: 'Conselheiro Lafaiete, MG',
      text: 'Super recomendo a VitaLink. O sinal nunca cai e a velocidade é ótima.',
      rating: 4.5,
    },
    {
      avatar,
      name: 'Pedro Almeida',
      location: 'Conselheiro Lafaiete, MG',
      text: 'Empresa confiável, entregam exatamente o que prometem. Não troco por nada.',
      rating: 5.0,
    },
    {
      avatar,
      name: 'Lucas Santos',
      location: 'Conselheiro Lafaiete, MG',
      text: 'Melhor internet que já usei na região. Recomendo a todos.',
      rating: 5.0,
    },
  ];

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
      slidesToSlide: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 2,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating - fullStars >= 0.5;

    for (let i = 0; i < fullStars; i += 1) {
      stars.push(<FaStar key={`full-${i}`} color="#f3d36a" />);
    }

    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" color="#f3d36a" />);
    }

    while (stars.length < 5) {
      stars.push(<FaRegStar key={`empty-${stars.length}`} color="#c8d7ce" />);
    }

    return stars;
  };

  const CustomLeftArrow = ({ onClick }) => (
    <button className="custom-arrow left" onClick={onClick} aria-label="Anterior">
      <FaArrowLeft />
    </button>
  );

  const CustomRightArrow = ({ onClick }) => (
    <button className="custom-arrow right" onClick={onClick} aria-label="Próximo">
      <FaArrowRight />
    </button>
  );

  return (
    <section className="testimonials-section">
      <span className="testimonials-kicker">Clientes conectados</span>
      <h2>O que nossos clientes estão dizendo</h2>
      <p className="section-subtitle">
        Opiniões de quem já usa a VitaLink em Conselheiro Lafaiete.
      </p>
      <div className="testimonials-section-secondary">
        <Carousel
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={5000}
          keyBoardControl={true}
          showDots={true}
          renderDotsOutside={true}
          arrows={false}
          customLeftArrow={<CustomLeftArrow />}
          customRightArrow={<CustomRightArrow />}
          containerClass="carousel-container"
          dotListClass="custom-dot-list-style"
          itemClass="carousel-item-padding-40-px"
        >
          {testimonials.map((testimonial) => (
            <div key={testimonial.name} className="testimonial-card">
              <div className="testimonial-header">
                <img src={testimonial.avatar} alt={`Avatar de ${testimonial.name}`} className="testimonial-avatar" />
                <div className="testimonial-info">
                  <h4>{testimonial.name}</h4>
                  <p className="location">{testimonial.location}</p>
                  <div className="rating" aria-label={`Avaliação de ${testimonial.rating} estrelas`}>
                    {renderStars(testimonial.rating)}
                  </div>
                </div>
              </div>
              <p className="testimonial-text">"{testimonial.text}"</p>
            </div>
          ))}
        </Carousel>
      </div>
    </section>
  );
}

export default TestimonialsSection;
